import React from 'react';
import { ChevronDown } from 'lucide-react';

function sortRounds(rounds) {
  return [...rounds].sort((a, b) => {
    const numA = parseInt(String(a).replace(/\D/g, ''), 10);
    const numB = parseInt(String(b).replace(/\D/g, ''), 10);
    if (!Number.isNaN(numA) && !Number.isNaN(numB) && numA !== numB) {
      return numA - numB;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
  });
}

export function uniqueSortedRounds(items, getRound = (item) => item?.round) {
  const rounds = [...new Set((items || []).map(getRound).filter(Boolean))];
  return sortRounds(rounds);
}

export function RoundFilterTabs({
  language,
  view,
  onViewChange,
  selectedRound,
  onRoundChange,
  rounds,
  allLabel,
  filterLabel,
  ariaLabel,
  selectId = 'round-filter'
}) {
  const isRoundView = view === 'round';

  const tabs = [
    {
      id: 'round',
      label: filterLabel || (language === 'en' ? 'Filter by Round' : 'סינון לפי סיבוב')
    },
    {
      id: 'all',
      label: allLabel || (language === 'en' ? 'All games' : 'כל המשחקים')
    }
  ];

  return (
    <div className="space-y-3">
      <div
        role="tablist"
        aria-label={
          ariaLabel ||
          (language === 'en' ? 'Match filters' : 'סינון משחקים')
        }
        className="inline-flex w-full max-w-full flex-wrap rounded-2xl border border-slate-200 bg-slate-100/90 p-1 sm:w-auto"
      >
        {tabs.map((tab) => {
          const active = view === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onViewChange(tab.id)}
              className={[
                'min-h-[40px] flex-1 rounded-xl px-4 py-2 text-sm font-semibold transition-colors sm:flex-none',
                active
                  ? 'bg-brand-600 text-white shadow-sm'
                  : 'text-slate-600 hover:bg-white/70 hover:text-slate-900'
              ].join(' ')}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {isRoundView && (
        <div className="rounded-2xl border border-zinc-200/90 bg-white p-4 shadow-md shadow-zinc-900/5">
          <label
            htmlFor={selectId}
            className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-500"
          >
            {language === 'en' ? 'Round' : 'סיבוב'}
          </label>
          <div className="relative max-w-xs">
            <select
              id={selectId}
              value={selectedRound}
              onChange={(e) => onRoundChange(e.target.value)}
              className="tap-target w-full cursor-pointer appearance-none rounded-xl border border-zinc-200 bg-white py-2.5 pe-10 ps-3 text-sm font-semibold text-zinc-800 shadow-sm transition hover:border-zinc-300 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/25"
            >
              <option value="">
                {language === 'en' ? 'Select a round' : 'בחר סיבוב'}
              </option>
              {rounds.map((round) => (
                <option key={round} value={round}>
                  {round}
                </option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute end-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
          </div>
        </div>
      )}
    </div>
  );
}

export const UpcomingMatchTabs = RoundFilterTabs;
